import { render } from "./Change-delivery.vue?vue&type=template&id=e81f92ac&scoped=true"
import script from "./Change-delivery.vue?vue&type=script&lang=js"
export * from "./Change-delivery.vue?vue&type=script&lang=js"

import "./Change-delivery.vue?vue&type=style&index=0&id=e81f92ac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e81f92ac"]])

export default __exports__